/* Keep the native cart's checkout button amount in sync with the original Shopify subtotal. */
(function () {
  'use strict';
  function sync() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var source = drawer.querySelector('.cart__total__price[data-cart-total]');
    var target = drawer.querySelector('[data-rdl-cart-checkout-total]');
    if (!source || !target) return;
    var amount = source.textContent.trim();
    if (amount && target.textContent.trim() !== amount) target.textContent = amount;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
  else sync();
  if (!('MutationObserver' in window)) return;
  var observer = new MutationObserver(sync);
  function observe() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) observer.observe(drawer, {childList:true, characterData:true, subtree:true});
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, {once:true});
  else observe();
  document.addEventListener('shopify:section:load', observe);
})();
